var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReleaseDeviceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9039 15.6538L13.85 14.6L16.45 12L13.85 9.39998L14.9039 8.34615L17.5039 10.9462L20.1039 8.34615L21.1577 9.39998L18.5577 12L21.1577 14.6L20.1039 15.6538L17.5039 13.0538L14.9039 15.6538ZM7.06161 22.4999C6.56449 22.4999 6.13893 22.3229 5.78493 21.9689C5.43091 21.6149 5.25391 21.1894 5.25391 20.6923V3.3077C5.25391 2.81058 5.43091 2.38503 5.78493 2.03103C6.13893 1.67701 6.56449 1.5 7.06161 1.5H16.4462C16.9433 1.5 17.3688 1.67701 17.7228 2.03103C18.0768 2.38503 18.2539 2.81058 18.2539 3.3077V6.9615H16.7539V5.74995H6.75388V18.25H16.7539V17.0385H18.2539V20.6877C18.2539 21.1894 18.0768 21.6169 17.7228 21.9701C17.3688 22.3234 16.9433 22.5 16.4462 22.5H7.06161V22.4999Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReleaseDeviceIcon);
export default __webpack_public_path__ + "static/media/releaseDeviceIcon.71b9263d.svg";
export { ForwardRef as ReactComponent };